import React from 'react';
import { useSelector } from 'react-redux';
import Chip from 'lib/Chip';
import { Size } from 'lib/Chip/Chip.types';
import { getIsDirectSalesCampaignType } from 'store/dealManagement/selectors/getCampaignType';
import { bookingStatusStyles, defaultBookingStatusStyle, defaultDirectSalesBookingStatusStyle } from './consts';
import { ChipBookingStatusProps } from './ChipBookingStatus.types';

export const ChipBookingStatus = ({
  status,
  dataTestId = 'chip-booking-status',
  size = Size.SMALL,
}: ChipBookingStatusProps): React.ReactElement => {
  const isDirectSalesCampaignType = useSelector(getIsDirectSalesCampaignType);

  const defaultStyle = isDirectSalesCampaignType ? defaultDirectSalesBookingStatusStyle : defaultBookingStatusStyle;

  const styles = bookingStatusStyles[status] ?? defaultStyle;

  return <Chip label={styles.text} color={styles.style} size={size} dataTestId={dataTestId} />;
};
